import React from "react"
import MobileAppImg from "../components/assets/images/mobileapp.png"
import { FaCheck } from 'react-icons/fa';
import { SuccessStories } from "./SuccessStories";


export const OurApp = () => {
  return (
    <>
      <section className='instructor mb-16'>
        <div className='container'>
          <div className='heading py-12 text-center w-2/3 m-auto md:w-full'>
            <h1 className='text-3xl font-semibold text-black'>Download our app and be part of our growing community
            </h1>
            <span className='text-[18px] mt-2 block text-left py-3'>Download the PIP College app today and get the ultimate study companion for your August exams.
              With the PIP College app, you'll have access to:
            </span>
            <ol className="space-y-4 text-gray-700">
              <li className="flex items-center">
                <FaCheck className="mr-3 text-green-500 cursor-pointer" />
                Pre-recorded videos covering the entire syllabus of KASNEB courses.
              </li>
              <li className="flex items-center">
                <FaCheck className="mr-3 text-green-500 cursor-pointer" />
                Practice questions and mock exams to help you assess your progress.
              </li>
              <li className="flex items-center">
                <FaCheck className="mr-3 text-green-500 cursor-pointer" />
                Expert guidance from experienced professionals.
              </li>
              <li className="flex items-center">
                <FaCheck className="mr-3 text-green-500 cursor-pointer" />
                The flexibility to study whenever and wherever you want.
              </li>
            </ol>
            <span className='text-[18px] mt-2 block text-left py-3'>So what are you waiting for? Download the PIP College app today and start your August exam preparation with confidence!
            </span>
          </div>
          <div className='content grid grid-cols-2 gap-5 md:grid-cols-1'>
            <div className='images rounded-lg relative overflow-hidden h-72 w-ful before:bg-backbg before:h-72 before:w-full before:absolute before:top-0 before:left-0 before:content before:z-10'>
              <img src={MobileAppImg} alt='' className='rounded-t-lg object-contain w-full h-72' />
              <div className='categ flex flex-col gap-4 absolute top-5 z-30 m-3 p-8 items-center justify-center text-center'>
                <h2 className='text-3xl text-white font-semibold'>Download Our App</h2>
                <span className='text-[14px] text-white mt-2 block'>Get access to all our services and programs on your mobile device.</span>
                <button className='text-[15px] py-2 px-4 border border-gray-200 rounded-md bg-primary'>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pacesetter.pp&pcampaignid=web_share"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white no-underline block w-full h-full"
                  >
                    Download
                  </a>
                </button>
              </div>
            </div>
            <div className='images rounded-lg relative overflow-hidden h-72 w-ful before:bg-backbg before:h-72 before:w-full before:absolute before:top-0 before:left-0 before:content before:z-10'>
              <img src='https://bdevs.net/wp/educal/wp-content/uploads/2021/09/what-2.jpg' alt='' className='rounded-t-lg object-cover w-full h-72 relative' />
              <div className='categ flex flex-col gap-4 absolute top-5 z-30 m-3 p-8 items-center justify-center text-center'>
                <h2 className='text-3xl text-white font-semibold'>Visit our website</h2>
                <button className='text-[15px] py-2 px-4 border border-gray-200 rounded-md bg-primary'>
                  <a
                    href="https://www.student.pipkenya.online"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white no-underline block w-full h-full"
                  >
                    GO
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div className='content'>
            <div className='heading py-12 text-center w-2/3 m-auto md:w-full'>
              <h1 className='text-3xl font-semibold text-black'>We Are Proud</h1>
              <span className='text-[14px] mt-2 block'>Our industry-specific, practical training ensures learners gain relevant experience to thrive in their fields. Pacesetters is dedicated to developing well-rounded professionals who succeed in their careers and act as responsible leaders, making positive contributions to their organizations and communities.</span>
            </div>
            {/* <div className='content grid grid-cols-4 gap-5 md:grid-cols-2'>
              <InstructorCard color='text-red-500' icon={<FaUsers size={40} />} title='3000+' desc='Success Stories' />
              <InstructorCard color='text-orange-500' icon={<GiEvilBook size={40} />} title='20+' desc='Our Tutors' />
              <InstructorCard color='text-purple-500' icon={<FaGraduationCap size={40} />} title='1000' desc='Schedules' />
              <InstructorCard color='text-indigo-500' icon={<GiWorld size={40} />} title='4' desc='Courses' />
              </div> */}
          </div>
        </div>
        <SuccessStories />
      </section>
    </>
  )
}
export const InstructorCard = (props) => {
  return (
    <div className={`box p-5 py-5 rounded-md`}>
      <div className={`${props.color}`}>{props.icon}</div>
      <div className='text mt-2'>
        <h4 className='text-lg font-semibold text-black'>{props.title}</h4>
        <p className='text-[15px]'>{props.desc}</p>
      </div>
    </div>
  )
}
